// extracted by mini-css-extract-plugin
module.exports = {"portal":"Modal_Root_portal__EiU6H","overlay":"Modal_Root_overlay__a1CU6","content":"Modal_Root_content__rP50e","sizeMd":"Modal_Root_sizeMd__blTxO"};